import * as Mutations from './mutations';
import store from '@/store/store';
import { formatTelMask, formatTelMaskUK } from '@/common/utils/strings';
import {clearAllSelected} from '@/store/modules/page/reset';
import {PaginationParams} from '@/common/utils/pagination-params';
import {ParentsService} from '@/common/services/pages/parents.service';
import {ChildrenService} from '@/common/services/pages/children.service';
import {ApprovedPickupService} from '@/common/services/pages/approved-pickup.service';


export const ChildrenModule = {
    state: {
        contacts: null,
        contactGeneralData: null,
        contactRosterData: null,
        contactScheduleData: null,
        childrenList: [],
        children: null
    },

    mutations: {
        [Mutations.SET_CONTACTS](state, contacts) {
            contacts = _.map(contacts, contact => {
                contact.phone = store.getters.schoolCountry === 'England'
                    ? formatTelMaskUK(contact.phone)
                    : formatTelMask(contact.phone);
                return contact;
            });

            state.contacts = contacts;
        },

        [Mutations.SET_CHILDREN_LIST](state, children) {
            state.childrenList = children;
        },

        [Mutations.SET_CHILDREN](state, children) {
            state.children = children;
        },

        [Mutations.SET_CONTACT_GENERAL_DATA](state, data) {
            data.primaryContact.phoneNumber = store.getters.schoolCountry === 'England'
                ? formatTelMaskUK(data.primaryContact.phoneNumber)
                : formatTelMask(data.primaryContact.phoneNumber);

            data.secondaryContact.phoneNumber = store.getters.schoolCountry === 'England'
                ? formatTelMaskUK(data.secondaryContact.phoneNumber)
                : formatTelMask(data.secondaryContact.phoneNumber);

            if (data.specialNeeds === '') {
                data.specialNeeds = 'No needs';
            }

            state.contactGeneralData = data;
        },

        [Mutations.SET_CONTACT_ROSTER_DATA](state, data) {
            state.contactRosterData = data;
        },

        [Mutations.SET_CONTACT_SCHEDULE_DATA](state, data) {
            state.contactScheduleData = data;
        },

        [Mutations.REMOVE_CONTACT_GENERAL_DATA](state) {
            state.contactGeneralData = null;
        },

        [Mutations.REMOVE_CONTACT_ROSTER_DATA](state) {
            state.contactRosterData = null;
        },

        [Mutations.REMOVE_CONTACT_SCHEDULE_DATA](state) {
            state.contactScheduleData = null;
        }
    },

    actions: {
        async getContacts(context) {
            const [{ data: { content, pageable, totalPages, totalElements, numberOfElements } }, { data: parentCount }, { data: kidsCount }] =
                await Promise.all([
                    ChildrenService.getChildrenBySchool(context.getters.schoolId,
                        PaginationParams.createParams({
                            size: context.getters.pageSize,
                            page: context.getters.pageNumber,
                            sort: context.getters.sortBy,
                            direction: context.getters.direction,
                            query: context.getters.searchQuery,
                            filters: {
                                ...context.getters.filters
                            }
                        })),
                    ParentsService.getParentsCount(context.getters.schoolId),
                    ParentsService.getKidsCount(context.getters.schoolId)
                ]);
            context.commit(Mutations.SET_CONTACTS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getContacts');
                }
            });

            const stats = [
                {
                    label: 'Parents',
                    data: parentCount,
                    tooltip: 'Parents count'
                },
                {
                    label: 'Kids',
                    data: kidsCount,
                    tooltip: 'Kids count'
                }
            ];
            context.dispatch('setStats', stats);
            context.dispatch('resetSelectedItems');
        },

        async getChildren(context) {
            const { data } = await ChildrenService.getChildrenList(context.getters.schoolId);
            context.commit(Mutations.SET_CHILDREN_LIST, data);
        },

        async contactPreview(context, payload) {
            context.dispatch('openModal', {
                modalName: 'ContactPreviewModal',
                options: {
                    info: {
                        ...payload
                    }
                }
            })
        },

        async getChildrenForEnrollment(context) {
            const { data } = await ChildrenService.getChildrenForEnrollment(context.getters.schoolId);

            context.commit(Mutations.SET_CHILDREN, data);
        },

        async deleteContact(context, childId) {
            await ChildrenService.deleteContact(context.getters.schoolId, childId);
            clearAllSelected();
            await context.dispatch('getContacts');
        },

        async deleteMultipleContacts(context) {
            await ChildrenService.deleteContacts(context.getters.schoolId, context.getters.selected);
            await context.dispatch('getContacts');
            context.dispatch('resetSelectedItems');
        },

        async getContactGeneralInfo(context, payload) {
            const [contact, approvedPickups] = await Promise.all([
                ChildrenService.getChildGeneralInfoById(payload),
                ApprovedPickupService.getPickupsByChild(payload)])
                .then(responses =>
                    responses.map(response => response.data));

            contact.approvedPickups = approvedPickups;

            context.commit(Mutations.SET_CONTACT_GENERAL_DATA, contact);
        },

        async getContactRosterInfo(context, payload) {
            const params = {
                date: payload.date ? payload.date : null,
                activityType: payload.activityType,
                activityId: payload.activityId
            };
            const { data } = await ChildrenService.getChildRosterInfoById(payload.childId, params);

            context.commit(Mutations.SET_CONTACT_ROSTER_DATA, data);
        },

        async getContactScheduleInfo(context, payload) {
            const { data } = await ChildrenService.getChildScheduleInfoById(context.getters.schoolId, payload);
            context.commit(Mutations.SET_CONTACT_SCHEDULE_DATA, data);
        }
    },

    getters: {
        contacts: state => state.contacts,

        childrenList: state => state.childrenList,

        allChildren: state => state.children,

        contactGeneralData: state => state.contactGeneralData,

        contactRosterData: state => state.contactRosterData,

        contactScheduleData: state => state.contactScheduleData
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/children/children.module.js